// extracted by mini-css-extract-plugin
export var icon = "_at-3";
export var subtitle = "_at-2";
export var title = "_at-1";
export var value = "_at-0";